import React from 'react';
import { Calendar, ArrowRight, Download } from 'lucide-react';
import { Badge } from './ui/Badge';
interface AnnouncementCardProps {
  title: string;
  summary: string;
  date: string;
  category?: string;
  hasPdf?: boolean;
}
export function AnnouncementCard({
  title,
  summary,
  date,
  category = 'Umum',
  hasPdf = true
}: AnnouncementCardProps) {
  return <div className="bg-white border border-slate-200 rounded-lg p-6 hover:shadow-md transition-shadow" data-id="element-9">
      <div className="flex items-center justify-between mb-4" data-id="element-10">
        <Badge variant={category === 'Akuisisi' ? 'danger' : 'default'} data-id="element-11">
          {category}
        </Badge>
        <div className="flex items-center text-slate-500 text-sm" data-id="element-12">
          <Calendar className="w-4 h-4 mr-2" data-id="element-13" />
          {date}
        </div>
      </div>
      <h3 className="text-lg font-bold text-slate-900 mb-2 line-clamp-2" data-id="element-14">
        {title}
      </h3>
      <p className="text-slate-600 text-sm mb-6 line-clamp-3" data-id="element-15">{summary}</p>
      <div className="flex items-center justify-between pt-4 border-t border-slate-100" data-id="element-16">
        <button className="text-blue-900 text-sm font-medium hover:text-blue-700 flex items-center" data-id="element-17">
          Baca Selengkapnya <ArrowRight className="w-4 h-4 ml-1" data-id="element-18" />
        </button>
        {hasPdf && <button className="text-slate-500 hover:text-red-600 transition-colors" title="Unduh PDF" data-id="element-19">
            <Download className="w-5 h-5" data-id="element-20" />
          </button>}
      </div>
    </div>;
}